//App
import { CampaignContext } from "../CampaignContainer";

import useForm from "../../hooks/useForm";
import { CampaignContextData, CampaignProps } from "../../../types/campaign";

const useCampaign = (props: CampaignProps) => {
  return useForm<CampaignContextData, CampaignProps>(CampaignContext, props);
};

export default useCampaign;
